//Library Imports
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useCookies } from "react-cookie";
import { connect } from "react-redux";

// application components goes here
import GlobalStyle from "../../../../GlobalStyle";
import loginbg from "../../../../assets/img/login-bg.png";
import Nav from "./Nav";
import { ReactComponent as Logo } from "../../../../assets/img/Workbench_WhiteLogo.svg";
import ForgotUsername from "./ForgotUsername";
import SignUp from "./SignUp";
import ForgotPassword from "./ForgotPassword";
import PasswordReset from "./PasswordReset";
import LoginContainer from "./LoginContainer";
import { XIQ_ONLINE_URL } from "constants/index";

// styles goes here
import styled from "styled-components";

const Login: React.FC = (props) => {
  const [cookies, setCookie, removeCookie] = useCookies([]);
  const isLogout = cookies.isLogout;
  const [hostName, setHostName] = useState(window.location.hostname);
  const [redirectPath, setRedirectPath] = useState("");
  const history = useHistory();

  // Based on user's action renders respective component
  function conditionalRendering() {
    switch (redirectPath) {
      case "username":
        return (
          <ForgotUsername
            setRedirectPath={(value: string) => {
              setRedirectPath(value);
            }}
          />
        );
      // break;  // break after return is not reachable - it's redundant
      case "signup":
        return <SignUp />;
      case "password":
        return (
          <ForgotPassword
            setRedirectPath={(value: string) => {
              setRedirectPath(value);
            }}
          />
        );
      case "resetPassword":
        return (
          <PasswordReset
            setRedirectPath={(value: string) => {
              setRedirectPath(value);
            }}
          />
        );
      default:
        return (
          <LoginContainer
            setRedirectPath={(value: string) => {
              setRedirectPath(value);
            }}
          />
        );
    }
  }

  useEffect(() => {
    if (isLogout !== "1" && isLogout !== undefined) {
      //Default URL for logged in user if user hits "/"
      history.push("/campaigns");
    } else if (hostName !== "localhost") {
      window.location.href = `${XIQ_ONLINE_URL}auth/login?redirectURL=${window.location.protocol}//${window.location.host}`;
    }
    // const csrf_token = getCSRFToken();
    // if (csrf_token !== undefined && csrf_token !== null) {
    //   history.push("/content/explorer");
    // }
  }, []);

  return (
    <>
      {hostName === "localhost" ? (
        <>
          <GlobalStyle />
          <Wrapper>
            <div className="container-fluid" style={{ minHeight: "100vh" }}>
              <Header>
                <div className="row">
                  <div className="col-6">
                    <Logo />
                  </div>
                  <div className="col-6 d-flex justify-content-end">
                    <Nav />
                  </div>
                </div>
              </Header>
              <Content className="d-flex align-items-center">
                <div
                  className="row justify-content-between"
                  style={{ margin: "0 auto", width: "calc(100% - 0px)" }}
                >
                  <div className="col-xl-7 col-lg-6 d-flex align-items-center">
                    <Tagline>Helping you nurture today’s conversations, today</Tagline>
                  </div>
                  <div
                    className={`col d-flex justify-content-end ${
                      redirectPath === "resetPassword" ? "forgot" : "login-box"
                    }`}
                  >
                    {redirectPath !== undefined ? (
                      conditionalRendering()
                    ) : (
                      <LoginContainer
                        setRedirectPath={(value: string) => {
                          setRedirectPath(value);
                        }}
                      />
                    )}
                  </div>
                </div>
              </Content>
            </div>
          </Wrapper>
        </>
      ) : null}
    </>
  );
};

export default connect()(Login);

const Wrapper = styled.div`
  background-image: url(${loginbg});
  box-sizing: border-box;
  background-size: cover;
  min-height: 100vh;
  // height: 100vh;
`;
const Header = styled.header`
  padding: 80px 75px 0 75px;
  @media all and (max-width: 1439px), all and (max-height: 749px) {
    padding: 40px 75px 0 75px;
  }
  svg {
    height: 30px;
    width: auto;
    margin-top: -15px;
  }
`;
const Content = styled.section`
  padding: 25px 75px 0 75px;
  min-height: calc(100vh - 105px);
  @media all and (max-width: 1439px), all and (max-height: 749px) {
    // padding: 25px 75px 0 75px;
    min-height: calc(100vh - 85px);
  }
  .login-box {
    max-width: 500px;
    margin-right: -12px;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      max-width: 400px;
    }
  }
  .forgot {
    max-width: 500px;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      max-width: 450px;
    }
  }
`;
const Tagline = styled.h1`
  padding-left: 60px;
  margin: 0;
  font-size: 50px;
  font-weight: 600;
  color: #fff;
  font-family: "Roboto Slab", serif;
  @media all and (max-width: 1439px) {
    font-size: 32px;
  }
`;
